export interface IPaymentMethod {
  code: string;
  name: string;
  status: boolean;
  createdAt: string;
  updatedAt: string;
}

export class PaymentMethod implements IPaymentMethod {
  code: string;
  name: string;
  status: boolean;
  createdAt: string;
  updatedAt: string;

  constructor(json: IPaymentMethod) {
    this.code = json.code;
    this.name = json.name;
    this.status = json.status;
    this.createdAt = json.createdAt;
    this.updatedAt = json.updatedAt;
  }
}
